<div class="subbanner">
  <div class="container position-relative" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
    <div class="subbanner__title">
      <h1 class="primary-title">Mice Itineraries</h1>
    </div>
  </div>
</div>

<div class="container-fluid padding-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="selectedCountry">
          <li *ngFor="let country of uniqueCountryArray" [ngbNavItem]="country | lowercase"
            [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}">
            <a ngbNavLink class="main-heading-destini">{{ country | titlecase }}</a>
            <ng-template ngbNavContent>

              <section id="portfolio" class="portfoio portfolio-text">
                <div class="container-fluid" data-aos="fade-up">
                  <div class="row portfolio-container">
                    <ng-container *ngFor="let item of itinenary">
                      <div class="col-lg-3 col-md-6 portfolio-item filter-app"
                        [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}"
                        *ngIf="item && item.country && item.country.toLowerCase() === selectedCountry"
                        (click)="openDialog(item)">
                        <div *ngIf="item.tour_name">
                          <img [src]="item.CorporateTournameImages" (error)="handleImageError($event)" class="img-fluid"
                            [alt]="item.city" [title]="item.tour_name" width="295" height="220" loading="lazy" />
                          <div class="portfoio__caption">
                            <h4 class="portfoio__caption__title">{{ item.city |titlecase}}</h4>
                            <div class="portfoio__caption__sub-title">{{ item.tour_name }}</div>
                            <div class="portfoio__caption__day-nights-places">{{ item.day }} Days</div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </section>
            </ng-template>
          </li>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-2" [@animate]="{value:'*',params:{delay:'5ms',x:'-25px'}}"></div>
      </div>
    </div>


  </div>
</div>